<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 col-md-offset-4">
        <div class="login-panel panel panel-default">
          <div class="panel-heading form-panel__subtitle">
            <h3 class="panel-title">Авторизация</h3>
            <router-link to="/public/password_reset">
              Не помню пароль
            </router-link>
          </div>
          <div class="panel-body">
            <form @submit.prevent="logIn">
              <fieldset>
                <div class="form-group">
                  <input
                    maxlength="60"
                    class="form-control"
                    placeholder="Почта"
                    name="email"
                    v-model.trim="email"
                    autofocus
                  />
                </div>
                <div class="form-group">
                  <input
                    maxlength="40"
                    class="form-control"
                    placeholder="Пароль"
                    name="password"
                    type="password"
                    v-model.trim="password"
                  />
                </div>
                <button
                  type="submit"
                  class="btn btn-success"
                  :disabled="(!email || !password || wasSubmitted)"
                >
                  Войти
                </button>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import genericDataService from '@/services/genericDataService'
import { useNotification } from '@/mixins'
import { validateEmail, getActualDateInDatetime } from '@/services/utils'
export default {
  mixins: [
    useNotification,
  ],
  data () {
    return {
      wasSubmitted: false,
      email: '',
      password: '',
    }
  },
  methods: {
    async logIn () {
      if (!validateEmail(this.email)) {
        return this.showErrorNotification('Проверьте написание почты')
      }
      this.wasSubmitted = true
      const body = {
        email: this.email,
        password: this.password,
        authorization_date: getActualDateInDatetime()
      }
      try {
        const response = await genericDataService.logIn(body)
        localStorage.setItem('token', response.data.token)
        this.showSuccessNotification(`Добро пожаловать, ${this.email}!`)
        setTimeout(() => {
          this.$router.push('/')
        }, 1500)
      } catch (err) {
        const possibleErrors = [401, 404, 500]
        if (possibleErrors.includes(err.response.status)) {
          const { message } = err.response.data
          this.showErrorNotification(message)
        }
        this.wasSubmitted = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue